import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { AdminService } from '../admin.service';

@Injectable()
export class SuperAdminAuthGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private adminService: AdminService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const result = this.adminService.isAuthenticated.pipe(take(1));

    return result.pipe(
      map((isAuthenticated) => {
        const currentUser = this.adminService.getCurrentUser();

        if (!isAuthenticated) {
          this.router.navigateByUrl('/login');
        } else if (currentUser.role === 'admin') {
          this.router.navigateByUrl('/dashboard');
        }

        return currentUser.role === 'superadmin';
      })
    );
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const result = this.adminService.isAuthenticated.pipe(take(1));

    return result.pipe(
      map((isAuthenticated) => {
        const currentUser = this.adminService.getCurrentUser();

        if (!isAuthenticated) {
          this.router.navigateByUrl('/login');
        } else if (currentUser.role === 'admin') {
          this.router.navigateByUrl('/dashboard');
        }

        return currentUser.role === 'superadmin';
      })
    );
  }
}
